import { useMemo } from "react";
import { useAvailabilityData } from "../../../hooks/useAvailabilityData";
import { usePdpLayout } from "@redux/slices/pdpLayoutSlice";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import { ProductCategory } from "@utils/constants";
import { useGetPdpSectionLayout } from "../../../hooks/useGetSectionLayout";
import { PdpSections } from "@utils/customization";

interface UsePdpAvailabilityProps {
  product_type: ProductCategory;
  priceMode: number;
}

export const usePdpAvailability = ({
  product_type,
  priceMode,
}: UsePdpAvailabilityProps) => {
  const pdpLayout = usePdpLayout();

  const showAvailabilityDot = useAvailabilityData(
    pdpLayout?.[product_type ?? ""]?.availabilty_price_modes ??
      (product_type === ProductCategory.JEWELRY
        ? []
        : [PriceModes.GREEN, PriceModes.ORANGE, PriceModes.WHITE])
  );

  const summarySectionLayout = useGetPdpSectionLayout(
    PdpSections.SUMMARY,
    product_type
  );

  const showMatchingBandSection = useGetPdpSectionLayout(
    PdpSections.MATCHING_BAND_DETAILS,
    product_type
  );

  const isStockNumberVisible = useMemo(() => {
    const objStockNumber = summarySectionLayout?.sub_section?.stock_num;
    return objStockNumber?.price_modes?.includes(priceMode) ?? false;
  }, [summarySectionLayout, priceMode]);

  return {
    showAvailabilityDot,
    isStockNumberVisible,
    showMatchingBandSection,
  };
};
